module.exports = __webpack_public_path__ + "img/dashboard-screen-new.d5b27314.jpg";